"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryChartPromises = exports.initError = void 0;
const initError = function () {
  this.container.append('div').classed('chart-error', true).append('div').text('Unable to load data');
};
exports.initError = initError;
const tryChartPromises = async function (promises) {
  try {
    const {
      data,
      topMetrics,
      bottomMetrics,
      parent
    } = promises;
    const result = await Promise.all([data, topMetrics, bottomMetrics, parent]);
    return {
      data: result[0],
      topMetrics: result[1],
      bottomMetrics: result[2],
      parent: result[3]
    };
  } catch (e) {
    console.warn(e.message);
    if (this.container) {
      this.container.select('.chart-error').style('display', 'initial');
      this.container.select('.chart-loading').style('display', 'none');
      this.container.select(`.${this.cssPrefix}`).style('visibility', 'hidden');
    }
    return null;
  }
};
exports.tryChartPromises = tryChartPromises;